import {
  Appointmentdetails,
  Facility,
  Provider,
  SlotDetails,
  State,
} from "../store";
import * as API from "../api";

// update log
// FB 4371 DK    03/29/2021    Added to define the actions required for the appointment booking flow
// FB 4371 DK    04/20/2021    Added new param to send appointment type
// FB 4556 DK    07/07/2021    Implement client side error handling on PE
// FB 4638 MS    08/31/2021    Fixed Mobile view issues
// FB 6264 DK    11/22/2022    Migrate PE API,DB to EMR
// FB 7801 SK    12/14/2023    PE - Handling Appointment Types that have Differing Lengths of Time

export type Actions =
  | ModifyAppointmentDetails
  | GetProviderslist
  | GetFacilitieslist
  | GetStateList
  | Patient
  | ModifySlotDetails;

export type ModifyAppointmentDetails = {
  type: "MODIFY_APPOINTMENT_DETAILS";
  data: Appointmentdetails;
};

export type GetProviderslist = {
  type: "GET_PROVIDERS";
  data: Provider[];
};

export type GetFacilitieslist = {
  type: "GET_FACILITIES";
  data: Facility[];
};

export type GetStateList = {
  type: "GET_STATES";
  data: State[];
};

export type Patient = {
  type: "PATIENT";
  data: Patient;
};

export type ModifySlotDetails = {
  type: "MODIFY_SLOT_DETAILS";
  data: SlotDetails;
};

//FB 4371 DK    Added to modify the state whenever the slot details get updated
export async function modify_SlotDetails(
  obj: any,
  dispatch: React.Dispatch<Actions>
) {
  dispatch({
    type: "MODIFY_SLOT_DETAILS",
    data: {
      employeeId: obj.employeeId,
      facilityId: obj.facilityId,
      id: obj.id,
      slotDate: obj.slotDate,
      employeeName: obj.employeeName,
      facilityName: obj.facilityName,
      isslotexisting: obj.isslotexisting,
      duration: obj.duration, //FB 4638 added duration field
    },
  });
}

//FB 4371 DK    Added to modify the state whenever the appointment details get updated
export async function modify_AppointmentDetails(
  obj: any,
  dispatch: React.Dispatch<Actions>
) {
  dispatch({
    type: "MODIFY_APPOINTMENT_DETAILS",
    data: {
      appointmenttype: obj.appointmenttype,
      customappointmenttype: obj.customappointmenttype,//FB 7801
      appointmentfilter: obj.appointmentfilter,
      patientType: obj.patientType,
      isInsuranceExist: obj.isInsuranceExist,
      insurance: {
        id: obj.insurance.id,
        planId: obj.insurance.planId,
        name: obj.insurance.name,
        planName: obj.insurance.planName,
      },
      provider: obj.provider,
      location: {
        id: obj.location.id,
        name: obj.location.name,
        address: obj.location.address,
        region: obj.location.region,
        phone: obj.location.phone,
      },
      date: obj.date,
      duration:obj.duration //FB 4638 added duration field
    },
  });
}

//FB 4371 DK    Added to fetch the provider list from API
//FB 4371 DK    Added new param to send appointment type
export async function get_Providers(
  insurance_id: number,
  apptType: any,
  dispatch: React.Dispatch<Actions>
): Promise<void> {
  //FB 4371 DK    Added new param to send appointment type
  const providers = await API.GetProviders(insurance_id, apptType);
  dispatch({ type: "GET_PROVIDERS", data: providers });
}

//FB 4371 DK    Added to fetch the facility list from API
export async function get_Facilities(
  insurance_id: number,
  dispatch: React.Dispatch<Actions>
): Promise<void> {
  const facilities = await API.GetFacilities(insurance_id);
  dispatch({ type: "GET_FACILITIES", data: facilities });
}

//FB 4371 DK    Added to make POST call to create a new patient
export function create_patient(patientObj: any, appObj: any, id: number) {
  //FB 4556 DK - Implement client side error handling on PE - Start
  const response = API.createPatient(patientObj, appObj);
  API.removePreRegistration(id);
  return response;
  //FB 4556 DK - Implement client side error handling on PE - End
}

//FB 4371 DK    Added to make POST call to create a new appointment
export function create_appointment(appObj: any) {
  //FB 4556 DK - Implement client side error handling on PE - Start
  const response = API.createAppointment(appObj);
  return response;
  //FB 4556 DK - Implement client side error handling on PE - End
  //API.removePreRegistration(id);
}

//FB 4371 DK    Added to remove the selected slot from PreRegistration once the appointment is booked
export function remove_reg(id: number) {
  //API.createPatient(patientObj, appObj);
  API.removePreRegistration(id);
}

//FB 4371 DK    Added to fetch the states for State dropdowm menu on demographics page
export async function get_States(
  dispatch: React.Dispatch<Actions>
): Promise<void> {
  const states = await API.GetStates();
  dispatch({ type: "GET_STATES", data: states });
}

//FB-6264 Removed unused code